import React from "react";
import { ChevronRight } from "lucide-react";

/**
 * Breadcrumb "app-label > capitolo attivo".
 *
 * Props: appLabel, activeChapterTitle (opzionale)
 */
export function GuideBreadcrumb({ appLabel, activeChapterTitle }) {
  return (
    <nav
      className="flex items-center gap-1 text-[11px] text-suite-neutral-500"
      aria-label="Percorso"
      data-testid="guide-breadcrumb"
    >
      <span className="text-suite-neutral-400">Centro Guida</span>
      {appLabel && (
        <>
          <ChevronRight size={11} className="text-suite-neutral-300" />
          <span className="font-semibold text-suite-neutral-700">{appLabel}</span>
        </>
      )}
      {activeChapterTitle && (
        <>
          <ChevronRight size={11} className="text-suite-neutral-300" />
          <span className="text-suite-primary" data-testid="guide-breadcrumb-chapter">
            {activeChapterTitle}
          </span>
        </>
      )}
    </nav>
  );
}
